import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { Router } from "@angular/router";
import { StorageService } from "src/app/common/services/storage.service";
import {
  ButtonComponent,
  ButtonVariant,
} from "../../common/components/core/button/button.component";
import { InputComponent } from "../../common/components/core/input/input.component";

@Component({
  selector: "app-confirm-identity",
  templateUrl: "./confirm-identity.component.html",
  styleUrls: ["./confirm-identity.component.scss"],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ButtonComponent,
    MatFormFieldModule,
    InputComponent,
    MatCheckboxModule,
  ],
})
export class ConfirmIdentityComponent implements OnInit {
  confirmIdentityForm!: FormGroup;
  error = false;
  buttonVariant = ButtonVariant;
  hasChanges = false;
  declineMode = false;
  retryCount = 0;
  invalidNPI = false;
  token: string = "";
  refreshToken: string = "";
  user!: any;
  npiValue: string | undefined;

  constructor(private formBuilder: FormBuilder,
    private matDialogRef: MatDialogRef<ConfirmIdentityComponent>,
    private router: Router,
    private storageService: StorageService,) {}

  ngOnInit(): void {
    const { token, refreshToken, user } = this.storageService.getAndRemoveLoginData();
    this.token = token;
    this.refreshToken = refreshToken;
    this.user = user;
    const userData = JSON.parse(this.user);
    this.npiValue = userData?.npi;
    this.confirmIdentityForm = this.formBuilder.group({
      npi: [null, Validators.required],
      terms: [null],
    });
  }

  onContinue() {
    // get local storage npi and validate
    this.invalidNPI = false;
    const npiEntered = this.confirmIdentityForm.get('npi')?.value;
    if(this.npiValue === npiEntered) {
      this.storageService.resetLoginData(this.token, this.refreshToken, this.user);
      this.matDialogRef.close(false);
    } else {
       this.invalidNPI = true;
    }
  }
  // onContinue() {
  //   if (this.hasChanges) {
  //     this.router.navigate(["docreview", "doc-review"]);
  //   }
  //   this.hasChanges = true;
  //   this.confirmIdentityForm
  //     .get("terms")
  //     ?.addValidators(Validators.requiredTrue);
  // }

  onDecline() {
    this.declineMode = true;
  }
}
